import script from "./goodsGiftPack.vue?vue&type=script&setup=true&lang=js"
export * from "./goodsGiftPack.vue?vue&type=script&setup=true&lang=js"

import "./goodsGiftPack.vue?vue&type=style&index=0&id=eea2f418&lang=css"

const __exports__ = script;

export default __exports__